import { Image, Text, View } from '@react-pdf/renderer';
import { styles } from '../style/pdfStyles';
import { formatDate } from '../utils/normalize';
import {
  TRAVELIN_LOGO_DATA_URI,
  VISIT_BERGAMO_LOGO_DATA_URI,
} from '../assets/logos';

interface PdfCoverProps {
  structureName: string;
  address?: string;
  lastModified?: string;
}

export const PdfCover = ({ structureName, address, lastModified }: PdfCoverProps) => (
  <View style={styles.coverPage}>
    <View style={styles.coverLogos}>
      <Image src={TRAVELIN_LOGO_DATA_URI} style={styles.logoLarge} />
      <Image src={VISIT_BERGAMO_LOGO_DATA_URI} style={styles.logoLarge} />
    </View>

    <Text style={styles.title}>Passaporto di Accessibilita</Text>
    <Text style={styles.subtitle}>{structureName || 'Struttura'}</Text>
    {address ? <Text style={styles.text}>{address}</Text> : null}

    <View style={styles.block} />
    <Text style={styles.smallText}>
      Ultimo aggiornamento: {formatDate(lastModified) || '—'}
    </Text>
  </View>
);
